import { useMemo } from 'react'

import { Shimmer } from '@wartek-id/shimmer'

import { PengelolaanKinerjaTimeline } from 'app/KinerjaShared/components/PengelolaanKinerjaTimeline'
import CardPanduan from 'app/KinerjaShared/components/CardPanduan'
import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import { useAPIPelaksanaanSchools } from 'api/kinerja/useAPIKinerja'
import { PenilaianKinerjaPegawaiCard } from 'app/KinerjaShared/components/PenilaianKinerjaPegawaiCard'
import { PeriksaPerencanaanPegawaiCard } from 'app/KinerjaShared/components/PeriksaPerencanaanPegawaiCard'
import { PltKepalaSekolahConfirmationCard } from 'app/KinerjaShared/components/PltKepalaSekolahConfirmationCard'
import { PENGELOLAAN_KINERJA_PAMONG_PEJABAT_PENILAI_KINERJA_PATH } from 'app/KinerjaShared/constants/path'
import { MulaiPeriodeCard } from 'app/KinerjaShared/components/MulaiPeriodeCard'

export function Homepage() {
  // -----------------------------------------
  // Get school list
  // -----------------------------------------
  const { data: schoolsData, isLoading: isSchoolsLoading } =
    useAPIPelaksanaanSchools({
      options: {
        staleTime: 60 * 60 * 1000, // 1 hour
      },
    })

  const skbSchools = useMemo(() => {
    if (!schoolsData?.data) return []

    return (
      schoolsData.data.filter(
        (school) =>
          school.role === 'KS_DEFINITIF_SPNF' || school.role === 'KS_PLT_SPNF'
      ) || []
    )
  }, [schoolsData])

  // -----------------------------------------
  // Derived values
  // -----------------------------------------
  const isLoading = isSchoolsLoading

  return (
    <div className="flex w-full min-h-screen">
      <div className="flex-shrink-0 min-h-full">
        <div className="w-64">{/* Sentinel element for sidebar spacing */}</div>
        <KinerjaSidebar activeMenu="kepala-skb-penilai" sticky />
      </div>
      <div className="w-full gap-4 p-6 space-y-6">
        <MulaiPeriodeCard
          schools={skbSchools}
          pegawaiLabel="Pamong Belajar"
          atasanLabel="Tim Kinerja"
        />

        {isLoading ? (
          <>
            <Shimmer className="!h-40 !w-full block" />
            <Shimmer className="!h-40 !w-full block" />
          </>
        ) : (
          <>
            <PltKepalaSekolahConfirmationCard
              schools={skbSchools}
              kepalaSekolahLabel="Kepala SKB"
              pegawaiLabel="Pamong Belajar"
            />
            <PeriksaPerencanaanPegawaiCard
              schools={skbSchools}
              pegawaiLabel="Pamong Belajar"
              badgeText="Khusus Kepala SKB (Sanggar Kegiatan Belajar)"
              resolveNextPath={(school) =>
                `${PENGELOLAAN_KINERJA_PAMONG_PEJABAT_PENILAI_KINERJA_PATH}/perencanaan/${school.npsn}`
              }
            />
            <PenilaianKinerjaPegawaiCard
              schools={skbSchools}
              pegawaiLabel="Pamong Belajar"
              badgeText="Khusus Kepala SKB (Sanggar Kegiatan Belajar)"
              resolveNextPath={(school) =>
                `${PENGELOLAAN_KINERJA_PAMONG_PEJABAT_PENILAI_KINERJA_PATH}/pelaksanaan/${school.npsn}`
              }
            />
          </>
        )}

        <PengelolaanKinerjaTimeline
          timeline={[
            {
              title: 'Januari',
              steps: ['Perencanaan Kinerja'],
            },
            {
              title: 'Februari - November',
              steps: [
                'Persiapan Praktik Kinerja',
                'Pelaksanaan Observasi Praktik Kinerja',
                'Pelaksanaan Tindak Lanjut Praktik Kinerja',
              ],
            },
            {
              title: 'Desember',
              steps: ['Penetapan Predikat Kinerja'],
            },
          ]}
        />

        <CardPanduan />
      </div>
    </div>
  )
}
